<template>
  <div class="page-loading"></div>
</template>
<script>
export default {
  name: 'Loading',
  created() {
    this.$loading.show();
  }
};
</script>
